/**
 * Note: Here is the dynamic theme token data of the component,
 * It can automatically switch the  semantic design token of light and dark themes,
 * so that developers only need to define a component theme token
 * to automatically support light and dark theme modes
 */
import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        padding: 4,
        lineHeight: {
            default: 1,
            label: '14px',
            explain: '14px',
        },
        fontSize: {
            default: 14,
            small: 12,
        },
        fontFamily: typography.fontFamily,
        label: {
            color: semantic.text.stronger.neutral,
            descriptionColor: semantic.text.neutral,
            height: {
                vertical: 20,
            },
            description: {
                color: semantic.text.neutral,
                fontWeight: typography.fontWeight.body,
                fontSize: typography.fontSize.body,
                lineHeight: typography.lineHeight.body,
            },
        },
        count: {
            color: semantic.text.neutral,
            fontWeight: typography.fontWeight.subtitle,
            fontSize: typography.fontSize.subtitle,
            lineHeight: typography.lineHeight.subtitle,
        },
        control: {
            height: {
                default: 32,
                large: 40,
            },
        },
        margin: {
            xxs: 4,
            xs: 8,
            default: 16,
            large: 24,
        },
        color: {
            text: semantic.text.stronger.neutral,
            secondary: semantic.text.neutral,
            error: semantic.text.error,
            warning: semantic.text.warning,
            primary: semantic.text.primary,
            optional: semantic.text.neutral,
            tooltipIcon: semantic.icon.neutral,
        },
        border: {
            color: {
                default: semantic.border.neutral,
                error: semantic.border.error,
            },
            width: 1,
            type: 'solid',
        },
        motion: {
            duration: {
                mid: 0.2,
            },
            type: {
                easeOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
            },
        },
        screen: {
            max: {
                sm: 575,
            },
        },
    };
}
